import React, { Component, Fragment } from 'react';
import RequestForSignetApprovalRow from './RequestForSignetApprovalRow';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import SearchFilter from '../Reusable/SearchFilter';
import ModalForAddRequestForSignetApproval from './ModalForAddRequestForSignetApproval';
import withTranslations from '../../utils/HighOrderComponent';
import { addNewButton, createNotification } from '../../utils';
import {
  actionsRequestForSignetApproval,
  notificationTypeSuccess,
  requestForSignetApprovalStatuses,
} from '../../constants/globals';
import authorizationService from '../../securityUtils/authorizationService';

class RequestForSignetApprovalTable extends Component {
  constructor() {
    super();
    this.state = {
      show: false,
    };
  }

  showModal = (e) => {
    this.setState({
      show: true,
    });
  };

  handlePreviewClose = () => {
    this.setState({ show: false });
    this.props.deleteError();
  };

  handleAdd = (requestForSignetApproval, signalSubmit) => {
    const messages = this.props.t.NotificationMessages;
    const addOrDraft =
      signalSubmit === requestForSignetApprovalStatuses.SUBMIT.name
        ? messages.submitSuccess
        : messages.draftSuccess;
    this.props.createRequestForSignetApproval(
      requestForSignetApproval,
      this.handlePreviewClose,
      () =>
        createNotification(
          notificationTypeSuccess,
          messages.requestTitle,
          addOrDraft
        ),
      messages
    );
  };

  handleAddDecisionWithAttachment = (formData) => {
    this.props.createDecisionWithAttachment(formData, this.handlePreviewClose);
  };

  isModalOpened = () => {
    this.props.isModalOpened(this.state.show);
  };

  render() {
    const { t, isUserProcessor, isUserAuthorizedPerson, allowedActions } =
        this.props || {},
      { HeaderColumns, Labels, Tooltips } = t || {},
      { titleTable } = Labels || {};

    const requestForSignetApprovalList =
      this.props.requestForSignetApprovalList.map(
        (requestForSignetApproval, index) => (
          <RequestForSignetApprovalRow
            index={index + 1}
            key={requestForSignetApproval.id}
            requestForSignetApproval={requestForSignetApproval}
            deleteRequestForSignetApproval={
              this.props.deleteRequestForSignetApproval
            }
            deleteError={this.props.deleteError}
            error={this.props.error}
            createDecision={this.props.createDecision}
            findAllDecisionTypes={this.props.findAllDecisionTypes}
            decisionTypeList={this.props.decisionTypeList}
            deleteErrorDecision={this.props.deleteErrorDecision}
            errorDecision={this.props.errorDecision}
            showServerError={this.props.showServerError}
            createComplementRequestApproval={
              this.props.createComplementRequestApproval
            }
            findAllRequestForSignetsApprovalsPageble={
              this.props.findAllRequestForSignetsApprovalsPageble
            }
            activePage={this.props.activePage}
            numberOfItemsPerPage={this.props.numberOfItemsPerPage}
            handleAdd={this.handleAdd}
            complementRequestApproval={this.props.complementRequestApproval}
            findLastComplementRequestApprovalByRequestId={
              this.props.findLastComplementRequestApprovalByRequestId
            }
            clearComplementRequestApproval={
              this.props.clearComplementRequestApproval
            }
            isUserProcessor={isUserProcessor}
            isUserAuthorizedPerson={isUserAuthorizedPerson}
            Tooltips={Tooltips}
          />
        )
      );

    const isCreateButtonAllowed =
      allowedActions?.length > 0 &&
      authorizationService.isActionAllowed(
        actionsRequestForSignetApproval.REQUEST_FOR_SIGNET_APPROVAL_CREATE,
        allowedActions
      ) &&
      !isUserProcessor;
    const colStyle = isCreateButtonAllowed ? 'col-md-3' : 'col-md-3 ml-auto';
    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
                <Col className={colStyle}>
                  <SearchFilter noSearchColums={2} />
                </Col>
                {isCreateButtonAllowed && (
                  <Col className="addUser col-md-1">
                    {addNewButton(() => this.showModal(), Tooltips.addNew)}
                  </Col>
                )}
              </Row>
            </Card.Header>

            <Table responsive hover id="table">
              <thead>
                <tr className="text-center">
                  <th className="align-top" width="4%">
                    #
                  </th>
                  <th className="align-top">{HeaderColumns.kjsName}</th>
                  <th className="align-top">
                    {HeaderColumns.placeAndMunicipality}
                  </th>
                  <th className="align-top">{HeaderColumns.uniqueNumber}</th>
                  <th className="align-top" width="10%">
                    {HeaderColumns.pib}
                  </th>
                  <th className="align-top" width="11%">
                    {HeaderColumns.createdAt}
                  </th>
                  <th className="align-top" width="11%">
                    {HeaderColumns.status}
                  </th>
                  <th className="align-top" width="11%">
                    {HeaderColumns.decisionStatus}
                  </th>
                  <th className="align-top" width="11%">
                    {HeaderColumns.clientsEmail}
                  </th>
                  <th className="align-top" width="8%">
                    {HeaderColumns.note}
                  </th>
                  <th className="align-top" width="8%">
                    {HeaderColumns.processing}
                  </th>
                </tr>
              </thead>
              <tbody>{requestForSignetApprovalList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return (
      <Fragment>
        {table}
        {this.state.show && (
          <ModalForAddRequestForSignetApproval
            handleAdd={this.handleAdd}
            handleClose={this.handlePreviewClose}
            show={this.state.show}
            error={this.props.error}
            deleteError={this.props.deleteError}
            handleAddDecisionWithAttachment={
              this.handleAddDecisionWithAttachment
            }
            changeRequestForSignetApprovalStatus={
              this.props.changeRequestForSignetApprovalStatus
            }
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(
  RequestForSignetApprovalTable,
  'RequestForSignetApprovalTable'
);
